import { callZigzagFunction } from '../../callZigzagFunction';
import { zigzagHandler } from '../../handlers';

// 쇼핑몰 즐겨찾기 추가
export const abk = (shopMainDomain: string) => {
  return new Promise<boolean>(resolve => {
    callZigzagFunction('abk')({ shopMainDomain });
    zigzagHandler('onBookmarkStatus', maps => {
      resolve(maps[shopMainDomain]);
    });
  });
};
